import SuggestionChips from "./SuggestionChips";

const MASCOT_SRC = "/genie-mascots/role/support.png";

interface EmptyStateProps {
  firstName?: string;
  onSuggestionSelect: (text: string) => void;
  disabled?: boolean;
  isMobile?: boolean;
}

const EmptyState = ({ firstName, onSuggestionSelect, disabled, isMobile }: EmptyStateProps) => {
  const greeting = firstName ? `Hey ${firstName}, what can I help with?` : "What can I help with?";

  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-center max-w-sm px-4">
        <img
          src={MASCOT_SRC}
          className={isMobile ? "h-24 w-24 mx-auto mb-4 opacity-80" : "h-32 w-32 mx-auto mb-5 opacity-80"}
          alt=""
        />
        <h3 className="text-xl font-semibold text-gray-900 mb-2">
          {greeting}
        </h3>
        <p className="text-base text-gray-500 mb-5">
          Ask me about your calls, leads, genies, or anything about your business.
        </p>
        <SuggestionChips onSelect={onSuggestionSelect} disabled={disabled} />
      </div>
    </div>
  );
};

export default EmptyState;
